import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard.vue";
import Pemesanan from "@/pages/Pemesanan.vue";
import OrderLapangan from "@/pages/OrderLapangan.vue";
import RiwayatProduk from "@/pages/RiwayatProduk.vue";
import DaftarBarang from "@/pages/DaftarBarang.vue";
import DaftarLayanan from "@/pages/DaftarLayanan.vue";
import Print from "@/pages/Print.vue";
import Login from "../pages/Login.vue";
import Registrasi from "../pages/Registrasi.vue";
import CheckIn from "../pages/CheckIn.vue";
import CheckInHistory from "../pages/CheckInHistory.vue";
import RequiresAuth from './middleware/requires-auth';
import RequiresRoleCashier from './middleware/requires-role-cashier';
import IfAuth from './middleware/if-auth';

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: '/dashboard',
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          middlewares: [ RequiresRoleCashier ]
        },
      },
      {
        path: "daftar-barang",
        name: "Daftar Barang",
        component: DaftarBarang,
        meta: {
          middlewares: [ RequiresRoleCashier ]
        },
      },
      {
        path: "orders",
        name: "Pemesanan",
        component: Pemesanan,
        meta: {
          middlewares: [ RequiresRoleCashier ]
        },
      },
      {
        path: "riwayat-produk",
        name: "Riwayat Produk",
        component: RiwayatProduk,
        meta: {
          middlewares: [ RequiresRoleCashier ]
        },
      },
      {
        path: "daftar-layanan",
        name: "Daftar Layanan",
        component: DaftarLayanan,
        meta: {
          middlewares: [ RequiresRoleCashier ]
        },
      },
      {
        path: "order-jasa",
        name: "Pemesanan Layanan",
        component: OrderLapangan,
        meta: {
          middlewares: [ RequiresRoleCashier ]
        },
      },
    ],
    meta: {
			middlewares: [ RequiresAuth ]
		}
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
			middlewares: [ IfAuth ]
		}
  },
  {
    path: "/print/:id",
    name: "Print",
    component: Print,
    meta: {
      middlewares: [ RequiresRoleCashier ]
    },
  },
  {
    path: "/registrasi",
    name: "Registrasi",
    component: Registrasi,
    meta: {
      middlewares: [ RequiresAuth ]
    }
  },
  {
    path: "/checkIn",
    name: "CheckIn",
    component: CheckIn,
    meta: {
      middlewares: [ RequiresAuth ]
    }
  },
  {
    path: "/daftar-hadir",
    name: "CheckInHistory",
    component: CheckInHistory,
    meta: {
      middlewares: [ RequiresAuth ]
    }
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("@/pages/NotFound")
  }
];

export default routes;
